import { Fit, Layout, useRive } from "@rive-app/react-canvas";
import { memo } from "react";
import { SmileIcon } from "../smile-icon";

export const SmileIconAnimation = memo(function SmileIconAnimation() {
  const { RiveComponent, rive } = useRive({
    src: "/assets/animations/onboarding_logo_v2.riv",
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
    }),
  });

  // Show loading state whilst the Rive animation is loading
  const isLoading = !rive;

  return (
    <div className="relative z-10 flex h-[80px] w-[80px] items-center justify-center">
      {isLoading ? (
        <SmileIcon className="h-[80px] w-[80px]" />
      ) : (
        <RiveComponent className="h-full w-full" />
      )}
    </div>
  );
});
